<template>
    <div>
        <!--Header Components-->

        <base-header class="pb-2" type="">

        <b-row class="align-items-center py-4">
            <b-col lg="12" md="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active="loadingCounter > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="false" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6">
            <b-row class="mb-4">
                <template v-if="picklist.status == 'PENDING'">
                    <fab
                    position="bottom-left"
                    :bg-color="bgColor"
                    :actions="fabActions2"
                    @top="scrollTop()"
                    @back="clickOnBack"
                    @undo="undoLastAction"
                    main-icon="bolt"
                    v-if="loadingCounter == 0"
                    ></fab>
                </template>
                <b-col md="12" class="ml-3 mb--2"><h3>{{$route.params.id}}</h3></b-col>
                <b-col md="12">
                    <b-tabs pills card>
                        <b-tab v-if="classification.id != 'WAYBILLS'" class="mt--4" v-for="classification in picklist.classifications" :key="classification.id" :title="classification.id" @click="onClickClassification(classification)">
                        </b-tab>
                    </b-tabs>
                </b-col>
                <b-col md="12" v-if="selectedClassification == 'Custom'">
                    <b-card>
                        <b-row>
                            <b-col md="3">
                                <b-input type="number" placeholder="SKU (Min)" v-model="filter.skus_min"></b-input>
                            </b-col>
                            <b-col md="3">                                
                                <b-input type="number" placeholder="SKU (Max)" v-model="filter.skus_max"></b-input>
                            </b-col>
                            <b-col md="3">
                                <b-input type="number" placeholder="Qty (Min)" v-model="filter.qty_min"></b-input>
                            </b-col>
                            <b-col md="3">                                
                                <b-input type="number" placeholder="Qty (Max)" v-model="filter.qty_max"></b-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="6">
                                <multiselect
                                    open-direction="bottom"
                                    :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                    placeholder="Include Categories"
                                    label="name"
                                    track-by="id"
                                    :options="product_categories"
                                    text-field="name"
                                    :multiple="true"
                                    v-model="filter.categoriesInclude"
                                    :taggable="false"
                                    :disabled="loadingCounter > 0"
                                    />
                            </b-col>
                            <b-col md="6">
                                <multiselect
                                    open-direction="bottom"
                                    :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                    placeholder="Exclude Categories"
                                    label="name"
                                    track-by="id"
                                    :options="product_categories"
                                    text-field="name"
                                    :multiple="true"
                                    v-model="filter.categoriesExclude"
                                    :taggable="false"
                                    :disabled="loadingCounter > 0"
                                    />
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col md="12">
                                <b-button v-if="filterIsApplied" class="text-nowrap mb-2"
                                    @click="onClickApplyFilter(true)"
                                    variant="success">
                                    Apply
                                </b-button>
                                <b-button v-else class="text-nowrap mb-2"
                                    @click="onClickApplyFilter(false)"
                                    variant="success">
                                    Reset
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
                <b-col md="4">
                    <base-input :label="language_terms['SKUS']" :value="pickingItems.length" disabled>
                    </base-input>
                </b-col>
                <b-col md="4">
                    <base-input :label="language_terms['LOCATION']">
                        <el-select
                        @change="retrieveItemsByClassification()"
                        v-model="selectedLocation"
                        :placeholder="language_terms['LOCATION']"
                        >
                            <el-option
                                v-for="option in locations"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col md="4">
                    <base-input :label="language_terms['BRAND']">
                        <el-select
                        @change="retrieveItemsByClassification()"
                        v-model="selectedBrand"
                        filterable
                        :placeholder="language_terms['BRAND']"
                        >
                            <el-option
                                v-for="option in brands"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col md="12" class="mb-4">
                    <b-button class="text-nowrap mb-2"
                        @click="onClickDownloadPickList()"
                        variant="dark">
                        Download Picklist
                    </b-button>
                </b-col>
                <b-col md="12" v-if="pickingItems.length > 0">
                    <!-- $picking -->
                    <v-client-table v-model="pickingItems" :columns="pickingColumns" :options="pickingOptions">
                        <div slot="qty_open" slot-scope="{row, update}">
                            <base-input type="number" v-model="row.qty_open" @input="update" min="0" :max="row.qty" :disabled="isPickListBatchClosed"></base-input>
                            <!-- <base-input type="number" v-model="row.picked" :placeholder="row.qty"></base-input> -->
                        </div>
                        <div slot="action" slot-scope="{row}">
                            <b-button @click="clickOnPickItem(row);"  variant="success" :disabled="isPickListBatchClosed">
                                <b-icon icon="basket" aria-hidden="true"></b-icon>
                            </b-button>        
                        </div>
                    </v-client-table>
                </b-col>

                <b-col md="12" v-if="0">
                    <b-card>
                        <b-row v-if="0">
                            <b-col md="3">
                                <base-input :label="language_terms['DATE']" disabled>
                                    <flat-picker
                                        disabled
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        style="background-color: white"
                                        class="form-control datepicker"
                                        v-model="picklist.date">
                                    </flat-picker>
                                </base-input>
                            </b-col>

                            <b-col md="4" class="mb-4">
                                <base-input :label="language_terms['CLASSIFICATION']">
                                    <el-select
                                    @change="retrieveItemsByClassification"
                                    v-model="selectedClassification"
                                    filterable
                                    :placeholder="language_terms['CLASSIFICATION']"
                                    >
                                        <el-option
                                            v-for="option in picklist.classifications"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id">
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </b-col>

                            <b-col md="3">
                                <base-input :label="language_terms['SKUS']" :value="pickingItems.length" disabled>
                                </base-input>
                            </b-col>

                            <b-col md="2" class="mt-3">
                                <div class="mt-3">
                                    <b-button @click="closeBatch()"  variant="success" :disabled="isPickListBatchClosed">
                                        Close Batch
                                        <b-icon icon="lock" aria-hidden="true">
                                        </b-icon>
                                    </b-button>
                                </div>
        
                            </b-col>

                            <!-- <b-col md="3">
                                <base-input :label="language_terms['LOCATIONS']" :value="pickingItems.length" disabled>
                                </base-input>
                            </b-col> -->
                        </b-row>
                        <b-row>
                            <b-col md="12" v-if="pickingItems.length > 0 && 0">
                                <!-- $picking -->
                                <v-client-table v-model="pickingItems" :columns="pickingColumns" :options="pickingOptions">
                                    <div slot="qty_open" slot-scope="{row, update}">
                                        <base-input type="number" v-model="row.qty_open" @input="update" min="0" :max="row.qty" :disabled="isPickListBatchClosed"></base-input>
                                        <!-- <base-input type="number" v-model="row.picked" :placeholder="row.qty"></base-input> -->
                                    </div>
                                    <div slot="action" slot-scope="{row}">
                                        <b-button @click="clickOnPickItem(row);"  variant="success" :disabled="isPickListBatchClosed">
                                            <b-icon icon="basket" aria-hidden="true"></b-icon>
                                        </b-button>        
                                    </div>
                                </v-client-table>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>            
        </b-container>

        <b-modal centered header-bg-variant="light" header-text-variant="" title="Confirmation" v-model="modalConfirmBatchClose" @ok="confirmCloseBatch()">
            Proceed to close batch?
        </b-modal>

        <b-modal hide-backdrop content-class="shadow" centered title="Error" v-model="modalError" ok-only>
            <p class="my-2">{{modalErrorMessage}}</p>
        </b-modal>

    </div>
    
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
</style>
<script>
// import * as Printjs from "print-js"
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import { mapState } from "vuex";
import axios from "axios";
import fab from 'vue-fab'  

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from 'element-ui'

export default {
    name:'Location-Details',
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            storage_classifications: state => state.storageclassifications.storage_classifications,
            active_locations: state => state.locations.active_locations,
            location_created: state => state.locations.is_created,
            location_updated: state => state.locations.is_updated,
            location_filter: state => state.locations.filter,
            location_data: state => state.locations.data,
            product_categories: state => state.products.product_categories,
        })
    },
    data(){
        return{
            filterIsApplied:false,
            filter:{categoriesInclude:[], categoriesInclude:[], skus_min:null, skus_max:null, qty_min:null, qty_max:null},
            pickItemsHistory:[],
            locations:[],
            brands:[],
            waybill_code:null,
            modalError:false,
            modalErrorMessage: '',
            waybill:null,
            gtin:'',
            modalConfirmBatchClose:false,
            isPickListBatchClosed: true,
            pdfFile: '',
            pickingColumns:['id','location', 'brand', 'qty', 'product_name', 'qty_open', 'action'],
            // pickingOptions:{groupBy :['location', 'brand']},
            pickingOptions:{perPage:10000, perPageValues:[],stickyHeader:false, stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false
            ,texts:{count:"", filter: "", filterPlaceholder: "Quick Lookup",}
            ,editableColumns: ['qty_open']                        
            ,sortIcon: {
            is: "glyphicon-sort",
            base: "glyphicon",
            up: "glyphicon-chevron-up",
            down: "glyphicon-chevron-down"
            },
            sortingAlgorithm(data, column) {
            return data.sort(this.getSortFn(column));
            },
            },

            pickingItems: [],
            selectedClassification: null,
            selectedLocation:null,
            selectedBrand:null,
            picklist:{
                id:null,
                slots:[],
                stats:{},
                classifications:[],
            },
            loadingCounter:0,
            title:"",
            is_edit:false,
            bgColor: '#17BA19',
            position: 'bottom-right',
            fabActions: [
            {
                    name: 'generate',
                    icon: 'local_mall',
                    color: 'orange'
                },
                {
                    name: 'pack',
                    icon: 'local_shipping',
                    color: '#42b0f5'
                },
                {
                    name: 'generate2',
                    icon: 'local_mall',
                    color: 'gray'
                },
                {
                    name: 'pack2',
                    icon: 'local_shipping',
                    color: 'gray'
                }                
            ],
            fabActions2: [
                {
                    name: 'back',
                    icon: 'arrow_back',
                    color: 'red',
                },
                {
                    name: 'top',
                    icon: 'north',
                    color: 'green'
                },
                {
                    name: 'undo',
                    icon: 'undo',
                    color: 'blue'
                }                                   
            ],          
            selectedSlotsCount:0,
            masks: {
            weekdays: 'WWW',
            },
            attributes: [],
        }
    },
    components:{
        flatPicker,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        fab,
    },
    async mounted()
    {
        await this.$store.dispatch("products/fetchAllCategories", {})
        await this.retrievePickList(this.$route.params.id)
        this.onClickClassification(this.picklist.classifications[0])
    },
    methods:{
        async onClickApplyFilter(applyMode)
        {
            this.filterIsApplied = applyMode
        },
        async onClickDownloadPickList()
        {
            this.retrieveItemsByClassification(1)
            // alert(this.selectedClassification)
        },
        async onClickDownloadWaybills(row, mode)
        {
            this.loadingCounter++

            if (1)
            {
                let apiUrl = apiRoutes['DBASE_DOWNLOAD_WAYBILLS']
                await axios.post(apiUrl, {picklist_id:this.picklist.id, classification:row.classification, mode:mode}, {responseType: 'blob'}
                ).then((response) => {
                    const url = URL.createObjectURL(new Blob([response.data], authHeader()))
                    const link = document.createElement('a')
                    let filename = ''
                    if (mode == 'waybills')
                        filename = this.picklist.code + ' Waybills (' + row.classification.substr(5, 999) + ').pdf'
                    else if (mode == 'skus')
                        filename = this.picklist.code + ' SKUs (' + row.classification.substr(5, 999) + ').xlsx'

                    link.href = url
                    link.setAttribute('download',  filename)
                    document.body.appendChild(link)
                    link.click()
                });
            }
            this.loadingCounter--
        },
        scrollTop()
        {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // document.getElementById('app').scrollIntoView();
        },
        onClickClassification(classification)
        {
            this.selectedClassification = classification.id
            this.selectedLocation = null
            this.selectedBrand = null
            this.retrieveItemsByClassification()
        },
        confirmCloseBatch()
        {
            let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification}
            axios.post(apiRoutes["PICKLIST_CLOSE_BATCH"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.isPickListBatchClosed = true    
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                    Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
            });

        },
        closeBatch()
        {
            this.modalConfirmBatchClose = true
        },
        clickOnPickItem(row)
        {
            for (let x = 0; x < this.pickingItems.length; x++) {
                if (this.pickingItems[x].id == row.id)
                {
                    let payload = {picklist_item_id: row.id, qty: row.qty_open}
                    axios.post(apiRoutes["PICKLIST_UPDATE_ITEM_QTY_INCREMENTAL"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) 
                        {
                            // Save history for undo action
                            let item = {picklist_item_id: row.id, qty: row.qty_open, index: x}
                            this.pickItemsHistory.push(item)
                            this.$delete(this.pickingItems, x)
                        } 
                    })
                    .catch((error) => 
                    {
                        if (error.response) 
                            Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
                    });
                    break
                }
            }            
        },
        async retrieveItemsByClassification(isDownload = 0)
        {
            let selectedLocation = this.selectedLocation
            let selectedBrand = this.selectedBrand
            
            if (isDownload == 0)
            {
                this.loadingCounter++
                if (this.selectedClassification == 'Custom')
                {
                    this.pickingItems = []    
                }
                else
                {
                    let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification
                    ,filter_qty_open:true, filter_batch_closed:false, filter_location:selectedLocation, filter_brand:selectedBrand, is_download:isDownload};
                    axios.post(apiRoutes["PICKLIST_RETRIEVE_ITEMS_BY_CLASSIFICATION"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) 
                        {
                            this.isPickListBatchClosed = response.data.data.is_batch_closed
                            this.locations = response.data.data.locations
                            this.brands = response.data.data.brands

                            this.selectedLocation = selectedLocation
                            this.selectedBrand = selectedBrand

                            this.pickingItems = response.data.data.items

                            this.loadingCounter--
                        } 
                    })
                    .catch((error) => 
                    {
                        if (error.response) 
                        {
                            this.loadingCounter--
                            Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
                        } 
                        else 
                        {
                        console.log("Problem Querying Data", error);
                        }
                    });
                }
                this.loadingCounter--
            }
            else
            {
                this.loadingCounter++
                let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification
                ,filter_qty_open:true, filter_batch_closed:false, filter_location:selectedLocation, filter_brand:selectedBrand, is_download:isDownload};

                axios({
                method: 'post', // Use POST as the HTTP method
                url: apiRoutes["PICKLIST_RETRIEVE_ITEMS_BY_CLASSIFICATION"], // Replace with your API endpoint
                responseType: 'blob', // Treat the response as binary data (a file)
                data: payload, // Include the payload data in the request
                headers: authHeader()['headers'],
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'pickist.xlsx'); // Set the desired filename and extension
                    document.body.appendChild(link);
                    link.click();

                    this.loadingCounter--;
                })
                .catch((error) => {
                    console.error('Error downloading file:', error);
                });
                this.loadingCounter--                            
            }
        },
        undoLastAction()
        {
            let item = this.pickItemsHistory.pop()
            //{picklist_item_id: row.id, qty: row.qty_open, index: x}
            let payload = {picklist_item_id: item.picklist_item_id, qty: item.qty * -1}
            axios.post(apiRoutes["PICKLIST_UPDATE_ITEM_QTY_INCREMENTAL"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.retrieveItemsByClassification()        
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                    Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
            });

        },
        clickOnBack()
        {
            this.$router.push("/inventory/job/" + this.$route.params.id)
        },
        async retrievePickList(picklist_code)
        {
            this.loadingCounter++
            let payload = {code: picklist_code, classifications_only:1}
            await axios.post(apiRoutes["PICKLIST_RETRIEVE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.picklist = response.data.data
                    this.picklist.classifications.push({id: "WAYBILLS", name: "WAYBILLS", waybills_completed: "20", waybills_remaining: "49"})
                    this.loadingCounter--
                } 
            })
            .catch((error) => 
            {
                this.loadingCounter--
                if (error.response) 
                    Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
            });
        },
        async create()
        {

        },
        async update()
        {

        },
        cancel()
        {

        }
    }
}
</script>
